// Single source of truth for the public auth routes — pages reachable
// without a session (sign-up, password reset, email confirmation, …).
//
// Consumed by:
//   - AuthProvider, to render these pages for anonymous users instead of
//     bouncing to /login.
//   - api/client, to suppress the SPA-wide 401 redirect on these pages.
//     Without that suppression, the benign 401 from the initial
//     loadTenant() probe (fired on every fresh page load) hard-redirects
//     a freshly-opened reset/confirm link to /login before its form can
//     render.
//
// Keep this list authoritative; do not re-declare it elsewhere.
export const ANONYMOUS_ROUTES = new Set([
  "/login",
  "/signup",
  "/forgot-password",
  "/reset-password",
  "/confirm-email",
]);

export function isAnonymousRoute(pathname: string): boolean {
  return ANONYMOUS_ROUTES.has(pathname);
}
